import React, { Children } from 'react'
import PropTypes from 'prop-types'
import { If } from '../Conditionals'

import styles from './InlineBulletedList.module.scss'

const propTypes = {
  children: PropTypes.any,
}

const InlineBulletedList = ({ children }) => (
  <If condition={children}>
    <ul className={styles.list}>
      {Children.toArray(children).map((child, index) => (
        <li className={styles.listItem} key={`li-${child.key || index}`}>
          {child}
        </li>
      ))}
    </ul>
  </If>
)

InlineBulletedList.propTypes = propTypes

export default InlineBulletedList
